import React from 'react';

import BaseIcon, { BaseIconProps } from './BaseIcon';

const ErrorCrossIcon = ({ viewBox, ...restProps }: BaseIconProps) => (
  <BaseIcon {...restProps} viewBox={viewBox || '0 0 24 24'}>
    <rect
      width="17.9246"
      height="1.23916"
      rx="0.619582"
      transform="matrix(0.698472 -0.715638 0.698472 0.715638 5.47168 17.9707)"
      fill="#070A0D"
    />
    <rect
      width="17.9246"
      height="1.23916"
      rx="0.619582"
      transform="matrix(-0.698472 -0.715638 -0.698472 0.715638 18.5283 17.9707)"
      fill="#070A0D"
    />
  </BaseIcon>
);

export default ErrorCrossIcon;
